import React from "react";
import { FileText } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { useSeo } from "@/components/Seo";

export default function Terms() {
  useSeo({
    title: "Terms & Conditions | Tezz Khana Catering Service",
    description: "Read the booking terms and conditions for Tezz Khana Catering Service — advance payment, menu confirmation, cancellation and more.",
    path: "/terms",
  });
  const { settings } = useApp();
  const body = settings?.terms_and_conditions || "";
  return (
    <div className="container-x py-16">
      <div className="max-w-3xl">
        <span className="kbd-eyebrow"><FileText className="mr-1 inline h-3 w-3" /> Terms</span>
        <h1 className="mt-4 text-4xl font-semibold text-secondary sm:text-5xl">Terms &amp; Conditions</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Owner-approved terms. Any change is managed by Tezz Khana Admin.
        </p>
      </div>

      <article
        data-testid="terms-body"
        className="mt-10 max-w-3xl whitespace-pre-wrap rounded-2xl border border-border/70 bg-card p-8 text-sm leading-relaxed text-secondary"
      >
        {body || "Terms & Conditions are being finalised."}
      </article>
    </div>
  );
}
